import React from 'react';
import moment from 'moment-timezone';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '../Avatar';

const { standardizePhoneNumber } = require('../../util/standardizePhoneNumber');

const VisitInformation = ({
  provider,
  tenancy,
  appointmentTime,
  isAptRequest,
  classes: {
    paperRoot,
    gridRoot,
    providerProfile,
    metadata,
    metadataTitle,
    metadataText,
    avatar,
  }
}) => {
  const { phone: providerPhone } = provider;
  const { location: providerAddress } = tenancy;
  const time = moment(appointmentTime).tz('America/New_York').format('ddd, MMM Do - h:mm a z');

  return (
    <Paper className={paperRoot}>
      <Grid container className={gridRoot}>
      <Grid item container xs={12} className={providerProfile} justifyContent="centers">
        <Avatar
          providerId={provider.id}
          onClick={provider.providerUrl ? () => window.location.assign(`${process.env.REACT_APP_HOMEPAGE_URL}${provider.providerUrl}`) : null}
          className={avatar}
        />
        <p>
          {provider.fullTitle}
        </p>
      </Grid>

        { !isAptRequest &&
        <Grid item xs={12} className={metadata}>
          <span className={metadataTitle}>Date & Time</span>
          <span className={metadataText}>{time}</span>
          <span className={metadataTitle}>Contact</span>
          <span className={metadataText}>
            {standardizePhoneNumber(providerPhone)}
          </span>
          <span className={metadataTitle}>Location</span>
          <span className={metadataText}>
            {providerAddress || 'N/A'}
          </span>
        </Grid>
        }
      </Grid>
    </Paper>
  );
};

const styles = () => ({
  paperRoot: {
    backgroundColor: '#ebf5ff',
    height: 'max-content',
    padding: '1rem',
  },
  gridRoot: {
    height: '100%',
  },
  providerProfile: {
    paddingBottom: '24px',
    borderBottom: '1px solid #979797',
    justifyContent: 'center',
  },
  avatar:  {
    width: '80%',
    maxWidth: '150px',
    height: 'auto',
  },
  icon: {
    fontSize: '10rem',
    display: 'block',
    margin: 'auto',
  },
  metadata: {
    borderTop: '1px solid #979797',
    paddingTop: '24px',
  },
  metadataTitle: {
    color: '#606A74',
    fontSize: '12px',
    lineHeight: '14px',
    display: 'block',
  },
  metadataText: {
    color: '#1C1C1C',
    fontSize: '16px',
    lineHeight: '19px',
    display: 'block',
    paddingBottom: '16px',
    '@media only screen and (max-width: 1024px)': {
      fontSize: '1.3em',
    },
  },
});

export default withStyles(styles)(VisitInformation);
